import { put, select, takeLatest, delay } from 'redux-saga/effects';
import { Utils, DateUtils } from 'mw-style-react';
import {
  CHECK_SESSION,
  SHOW_SESSION_MODAL,
  SET_MODAL,
  APP_AUTH_KEY,
} from 'constants';

const INTERVAL = 10000;

/**
 * Показать модалку с уведомлением о том что сессия закончилась
 * @returns {IterableIterator<*>}
 */
function* showModal() {
  yield put({
    type: SET_MODAL,
    payload: {
      name: 'InfoModal',
      data: {
        id: 'expiredSession',
        title: 'expiredSession',
        text: 'expiredSessionInfo',
        buttons: [
          {
            type: 'text',
            label: 'Cancel',
          },
          {
            type: 'default',
            label: 'Restart session',
            onClick: () => {
              Utils.delStorage(APP_AUTH_KEY);
              document.location.reload();
            },
          },
        ],
      },
    },
  });
}

/**
 * Проверка времени жизни сессии
 * @returns {IterableIterator<*>}
 */
function* checkSession() {
  const appAuth = yield select((state) => state.appAuth);
  const currentDate = DateUtils.unixtime();
  if (currentDate >= appAuth.expiredDate) {
    yield put({ type: SHOW_SESSION_MODAL });
    return;
  }
  yield delay(INTERVAL);
  yield put({ type: CHECK_SESSION });
}

function* expireSession() {
  yield takeLatest(CHECK_SESSION, checkSession);
  yield takeLatest(SHOW_SESSION_MODAL, showModal);
}

export default expireSession;
